import { Box, Card, CircularProgress, Grid, Icon, IconButton, Switch, InputLabel } from "@mui/material";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSelect from "components/MDSelect";
import MDTextArea from "components/MDTextArea";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { MDTextFieldCalendar } from "components/MDTextFiedCalendar";
import { useUser } from "context/UserContext";
import { Form, Formik, useFormikContext } from "formik";
import FormField from "layouts/pages/users/new-user/components/FormField";
import PropTypes from "prop-types";
import { useEffect, useState } from 'react';
import { errorAlert, successAlert } from "utils/Functions";
import { get, postNoResponse } from "utils/WebService";
import * as Yup from "yup";
import { LawyerTable } from "./LawyerTable";

export default function PeopleCreateEdit({ id, closeCreateEdit, refreshTable, casoProcessualId }) {
    const {
        nome,
        tipoParte,
        advogados } = configForm.formField;

    const {
        tipoPartesEnum
    } = useUser();

    const [isLoadingInfo, setIsLoadingInfo] = useState(false)
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;


    const handleSubmit = (values, actions) => {

        const body = {
            id: values.id,
            nome: values.nome,
            movimentacao: values.movimentacao,
            advogados: values.advogados,
            tipoParte: values.tipoParte?.code,
            dataSuspensao: values.data,
            dataFimSuspensao: values.dataFimSuspensao,
            motivo: values?.motivo ?? null,
            suspenso: values.suspenso,
            processoId: casoProcessualId,
            documento: values.documento ?? null,
            qtdDiasAvisoSuspensao: Number(values.qtdDiasAvisoSuspensao) ?? null
        };

        postNoResponse("/processo-parte/save", body)
            .then(() => {
                successAlert(!id ? "Parte criada com sucesso!" : "Alterações salvas!", handleSucess());
            })
            .catch(() => {
                errorAlert(!id ? "Erro ao criar parte!" : 'Erro ao salvar alterações.');
            })
            .finally(() => {
                actions.setSubmitting(false);
            });
    };

    function handleSucess() {
        closeCreateEdit()
        refreshTable()
    }

    return (
        <Card id="user-info">
            <Box display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1, paddingTop: 0.75 }}>
                    <MDTypography variant="h5">
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                <MDTypography variant="h6">{id ? "Editar" : "Adicionar"} Pessoa</MDTypography>
            </Box>
            <Formik
                initialValues={{
                    id: null,
                    nome: null,
                    advogados: [],
                    tipoParte: null,
                    data: null,
                    motivo: null,
                    documento: null,
                    qtdDiasAvisoSuspensao: null,
                    suspenso: false,
                    dataFimSuspensao: null
                }}
                validationSchema={clientValidations}
                onSubmit={(values, actions) => {
                    actions.setSubmitting(true);
                    handleSubmit(values, actions);
                }}>
                {({ values, errors, touched, isSubmitting, setFieldValue }) => {

                    const addRow = () => {
                        let rows = values?.advogados ? [...values.advogados] : [];
                        rows.push({ id: null, nome: "" });
                        setFieldValue('advogados', rows);
                    };

                    const deleteRow = (index) => {
                        let rows = [...values?.advogados];
                        rows = rows.filter((_, idx) => idx !== index);
                        setFieldValue('advogados', rows);
                    };

                    function handleTableData(array) {
                        return (index, newValue) => {
                            let rows = [...array];
                            rows[index] = { ...rows[index], nome: newValue };
                            setFieldValue('advogados', rows);
                        };
                    }

                    return (
                        <Form id={configForm.formId} autoComplete="off">
                            <FetchAndSetData
                                id={id}
                                setIsLoadingInfo={setIsLoadingInfo}
                                closeCreateEdit={closeCreateEdit}
                                tipoPartesEnum={tipoPartesEnum} />

                            <MDBox px={3}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={4}>
                                        <FormField
                                            loading={isLoadingInfo}
                                            type={nome.type}
                                            label={nome.label}
                                            name={nome.name}
                                            value={values.nome ?? ""}
                                            placeholder={nome.placeholder}
                                            error={errors.nome?.length > 0 && touched.nome}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Documento</InputLabel>
                                        <MDInput
                                            size="small"
                                            placeholder="Informe o CPF ou CNPJ..."
                                            value={values.documento ?? ""}
                                            onChange={({ target }) => setFieldValue("documento", target.value)}
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={4}>
                                        <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Tipo Parte</InputLabel>
                                        <MDSelect
                                            isLoading={isLoadingInfo}
                                            getOptionValue={option => option.code}
                                            getOptionLabel={option => option.name}
                                            name={tipoParte.name}
                                            placeholder={tipoParte.placeholder}
                                            value={values.tipoParte}
                                            options={tipoPartesEnum}
                                            onChange={selectedOptions => {
                                                setFieldValue('tipoParte', selectedOptions);
                                            }}
                                        />
                                        {errors.tipoParte && touched.tipoParte && (
                                            <MDTypography variant="caption" color="error">
                                                {errors.tipoParte}
                                            </MDTypography>
                                        )}
                                    </Grid>

                                    <Grid item xs={12} mt={1}>
                                        <MDTypography variant="h6" gutterBottom>
                                            Suspensão
                                        </MDTypography>
                                    </Grid>

                                    <Grid item xs={12} sm={4} mt={1} sx={{ paddingTop: '5px !important', marginTop: '0px !important' }}>
                                        <Box display="flex" alignItems="center" lineHeight={2}>
                                            <MDTypography variant="button">
                                                Suspenso
                                            </MDTypography>
                                            <Switch
                                                checked={values.suspenso || false}
                                                onChange={(event) => {
                                                    setFieldValue("suspenso", event.target.checked);
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </MDBox>
                            {values.suspenso && (
                                <MDBox px={3}>
                                    <Grid container spacing={3}>

                                        <Grid item xs={12} sm={3} mt={2}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Data Início</InputLabel>
                                            <MDTextFieldCalendar
                                                type="date"
                                                value={values.data || ""}
                                                fullWidth
                                                onChange={({ target }) => setFieldValue("data", target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                darkMode={darkMode}
                                            />
                                            {errors.data && touched.data && (
                                                <MDTypography variant="caption" color="error">
                                                    {errors.data}
                                                </MDTypography>
                                            )}
                                        </Grid>
                                        
                                        <Grid item xs={12} sm={3} mt={2}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Data Fim da Suspensão</InputLabel>
                                            <MDTextFieldCalendar
                                                type="date"
                                                value={values.dataFimSuspensao || ""}
                                                fullWidth
                                                onChange={({ target }) => setFieldValue("dataFimSuspensao", target.value)}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                darkMode={darkMode}
                                            />
                                            {errors.dataFimSuspensao && touched.dataFimSuspensao && (
                                                <MDTypography variant="caption" color="error">
                                                    {errors.dataFimSuspensao}
                                                </MDTypography>
                                            )}
                                        </Grid>

                                        <Grid item xs={12} sm={3} mt={2}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>
                                                Dias de antecedência para aviso
                                            </InputLabel>
                                            <MDInput
                                                size="small"
                                                type="number"
                                                placeholder="Digite aqui..."
                                                value={values.qtdDiasAvisoSuspensao ?? ""}
                                                onChange={({ target }) => setFieldValue("qtdDiasAvisoSuspensao", target.value)}
                                                fullWidth
                                            />
                                            {errors.qtdDiasAvisoSuspensao && touched.qtdDiasAvisoSuspensao && (
                                                <MDTypography variant="caption" color="error">
                                                    {errors.qtdDiasAvisoSuspensao}
                                                </MDTypography>
                                            )}
                                        </Grid>

                                    </Grid>

                                    <Grid container spacing={3} >
                                        <Grid item xs={12} sm={6} mt={3}>
                                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Motivo</InputLabel>
                                            <MDTextArea
                                                rows={5}
                                                placeholder="Digite aqui..."
                                                value={values.motivo || ""}
                                                onChange={({ target }) => setFieldValue("motivo", target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                </MDBox>
                            )}

                            <MDBox px={3}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} mt={3}>
                                        <MDTypography variant="h6" gutterBottom>
                                            Advogados
                                        </MDTypography>
                                    </Grid>
                                    <Grid item xs={12} style={{ paddingTop: 3 }}>
                                        <MDButton
                                            color="info"
                                            variant="contained"
                                            sx={{ display: 'flex', alignItems: 'center' }}
                                            onClick={() => {
                                                addRow();
                                            }}
                                        >
                                            <Icon style={{ marginRight: 3 }}>add_circle</Icon> Adicionar
                                        </MDButton>
                                    </Grid>
                                    {values.advogados?.length > 0 &&
                                        <Grid item xs={12} >
                                            <LawyerTable
                                                rows={values.advogados}
                                                removeRow={deleteRow}
                                                handleData={handleTableData(values.advogados)}
                                            />
                                        </Grid>
                                    }
                                </Grid>
                            </MDBox>

                            <Box display="flex" alignItems="center" justifyContent="end" p={2}>
                                <MDButton
                                    disabled={isLoadingInfo}
                                    size="large"
                                    variant="contained"
                                    color="info"
                                    circular={false}
                                    iconOnly={false}
                                    type="submit"
                                    endIcon={isSubmitting ?
                                        <CircularProgress
                                            color="inherit"
                                            size={20} sx={{ ml: 0, mr: 0 }} /> : null}>
                                    {!isSubmitting && (id ? "Salvar" : "Adicionar")}
                                </MDButton>
                            </Box>
                        </Form>)
                }}
            </Formik>
        </Card >
    );
};

const FetchAndSetData = ({ id, setIsLoadingInfo, closeCreateEdit, tipoPartesEnum }) => {
    const { setFieldValue } = useFormikContext();

    useEffect(() => {
        if (id) {
            setIsLoadingInfo(true);
            get(`/processo-parte/by-id/${id}`).then(data => {
                const { id,
                    nome,
                    tipoParte,
                    advogados,
                    documento,
                    dataSuspensao,
                    qtdDiasAvisoSuspensao,
                    motivo,
                    suspenso,
                    dataFimSuspensao
                } = data;

                setFieldValue('id', id);
                setFieldValue('nome', nome);
                setFieldValue('advogados', advogados);
                setFieldValue('documento', documento);
                setFieldValue('tipoParte', tipoPartesEnum?.find(ht => ht.code === tipoParte));
                setFieldValue('data', dataSuspensao);
                setFieldValue('dataFimSuspensao', dataFimSuspensao);
                setFieldValue('qtdDiasAvisoSuspensao', qtdDiasAvisoSuspensao);
                setFieldValue('motivo', motivo);
                setFieldValue('suspenso', suspenso);
                setIsLoadingInfo(false);
            }).catch(() => errorAlert("Parte não encontrada!", closeCreateEdit));
        }
    }, [id]);

    return null;
};

export const configForm = {
    formId: "configuration-form",
    formField: {
        nome: {
            name: "nome",
            label: "Nome",
            type: "text",
            placeholder: "Informe o nome...",
            errorMsg: "Campo Obrigatório. Somente espaços em brancos não são permitidos.",
        },
        tipoParte: {
            name: "tipoParte",
            placeholder: "Selecione",
            errorMsg: "Campo Obrigatório",
        },
    }
}

const {
    formField: {
        nome,
        tipoParte
    },
} = configForm;

export const clientValidations = Yup.object().shape({
    nome: Yup.string()
        .required(configForm.formField.nome.errorMsg),

    tipoParte: Yup.object()
        .required(configForm.formField.tipoParte.errorMsg),

    data: Yup.string().when('suspenso', {
        is: true,
        then: (schema) =>
            schema.required('Data da suspensão é obrigatória'),
        otherwise: (schema) => schema.nullable(),
    }),

    dataFimSuspensao: Yup.string().when('suspenso', {
        is: true,
        then: (schema) =>
            schema.required('Data do fim da suspensão é obrigatória'),
        otherwise: (schema) => schema.nullable(),
    }),

    qtdDiasAvisoSuspensao: Yup.number()
        .typeError('Informe um número válido')
        .when('suspenso', {
            is: true,
            then: (schema) =>
                schema.required('Dias de antecedência é obrigatório'),
            otherwise: (schema) => schema.nullable(),
        }),
});


PeopleCreateEdit.propTypes = {
    id: PropTypes.string,
    closeCreateEdit: PropTypes.func.isRequired,
};

